<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" @click="show">{{
                createTitle
            }}</v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="text">{{ dialogTitle }}</span>
            </v-card-title>
            <v-card-text class="mt-4">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    @submit.prevent="submit"
                >
                    <template v-for="(field, i) in computedFields">
                        <v-text-field
                            v-if="['text', 'password'].includes(field.type)"
                            :key="i"
                            :type="field.type"
                            v-model="form[field.key]"
                            :label="field.name"
                            :rules="field.rules"
                            outlined
                        ></v-text-field>
                        <v-select
                            v-if="'select' === field.type"
                            :key="i"
                            v-model="form[field.key]"
                            :label="field.name"
                            :rules="field.rules"
                            :items="field.items"
                            outlined
                        ></v-select>
                        <v-combobox
                            v-if="'combobox' === field.type"
                            :key="i"
                            v-model="form[field.key]"
                            :label="field.name"
                            :rules="field.rules"
                            :items="field.items"
                            multiple
                            small-chips
                            outlined
                        ></v-combobox>
                        <v-layout
                            v-if="'checkbox' === field.type"
                            :key="i"
                            align-center
                        >
                            <span class="mr-3">{{ field.name }}</span>
                            <v-switch
                                v-model="form[field.key]"
                                :rules="field.rules"
                                :items="field.items"
                                outlined
                            ></v-switch>
                        </v-layout>
                        <v-radio-group
                            v-if="'radio' === field.type"
                            :key="i"
                            v-model="form[field.key]"
                            :label="field.name"
                            :rules="field.rules"
                            row
                        >
                            <v-radio
                                v-for="(item, j) in field.items"
                                :key="j"
                                :label="item.text"
                                :value="item.value"
                            ></v-radio>
                        </v-radio-group>
                        <options-input
                            v-if="'options' === field.type"
                            :key="i"
                            v-model="form[field.key]"
                            :field="field"
                        >
                        </options-input>
                        <v-select
                            v-if="'options-answer' === field.type"
                            :key="i"
                            v-model="form[field.key]"
                            :label="field.name"
                            :rules="field.rules"
                            :items="optionsAnswerItems"
                            outlined
                        ></v-select>
                    </template>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="submit"
                    :loading="loading"
                    >確定</v-btn
                >
                <v-btn
                    color="grey darken-3"
                    text
                    @click="close"
                    :disabled="loading"
                    >取消</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from 'lodash';
import OptionsInput from '@/components/OptionsInput.vue';

export default {
    components: {
        OptionsInput,
    },
    props: {
        name: String,
        fields: Array,
        handleCreate: Function,
        handleUpdate: Function,
    },
    data: () => ({
        dialog: false,
        editMode: false,
        loading: false,
        valid: true,
        form: {},
    }),
    computed: {
        createTitle() {
            return `建立${this.name}`;
        },
        dialogTitle() {
            return (!this.editMode ? '建立' : '編輯') + this.name;
        },
        computedFields() {
            return _.chain(this.fields)
                .filter((field) => !this.editMode || !field.immutable)
                .map((field) => {
                    const rules = field.rules || [];
                    if (field.required) {
                        rules.push((v) => ![null, undefined].includes(v) || `請填寫${field.name}`);
                    }
                    return { ...field, rules };
                })
                .value();
        },
        optionsAnswerItems() {
            const optionsKey = _.chain(this.fields).find(['type', 'options']).get('key').value();
            return _.chain(this.form)
                .get(optionsKey)
                .map((option, i) => ({ text: option, value: i }))
                .value();
        },
    },
    methods: {
        initForm() {
            if (this.$refs.form) {
                this.form = {};
                this.$refs.form.resetValidation();
                this.$nextTick(() => {
                    // form 剛清空，要等下一個tick trigger init才會拿到正確的狀態
                    this.$refs.form.$emit('init'); // trigger options input init
                });
            }
            this.loading = false;
        },
        show() {
            this.initForm();
            this.editMode = false;
            this.dialog = true;
            this.setDefaultValue();
        },
        showUpdateDialog(data) {
            this.initForm();
            this.$nextTick(() => {
                this.form = { ...data };
                this.editMode = true;
                this.dialog = true;
                this.setDefaultValue();
            });
        },
        setDefaultValue() {
            _.chain(this.fields).filter((field) => field.default !== undefined).each((field) => {
                if (this.form[field.key] === undefined) {
                    this.form[field.key] = field.default;
                }
            }).value();
        },
        close() {
            this.dialog = false;
        },
        async submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                try {
                    if (!this.editMode) {
                        await this.handleCreate(this.form);
                    } else {
                        await this.handleUpdate(this.form);
                    }
                    this.close();
                } catch (e) {
                    this.$showApiError(e);
                } finally {
                    this.loading = false;
                }
            }
        },
    },
};
</script>
<style>
</style>
